import { FC, useEffect, useState, useRef } from "react";
import { IIdentityCardTypeInput } from "../../../../interfaces/Contact";
import { useGetListQuery } from "../../../../features/api/Api";
import { isExists, locale, params } from "../../../../utils";
import { AutocompleteDropDown } from "../../../../components";
import useLocales from "../../../../hooks/useLocales";
import { useDispatch } from "react-redux";
import { setIdentityCardTypes } from "../../../../features/customer/customerSlice";
import { useFormikContext } from "formik";
import { TurkeyNationalityId } from "../../../../utils/enum";

function usePreviousValue(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const IdentityCardTypeInput: FC<IIdentityCardTypeInput> = ({
  name,
  nationalityId,
}) => {
  const { translate } = useLocales();
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const formik: any = useFormikContext();
  const previousValue = usePreviousValue(nationalityId);

  const { data: identityCardTypes } = useGetListQuery<any>({
    resource: "fixity/customer/identityCardType",
    params,
  });

  useEffect(() => {
    if (previousValue && nationalityId !== previousValue) {
      formik.setFieldValue(name, "", true);
    }

    if (isExists(identityCardTypes?.data)) {
      let records: any[] = [];
      identityCardTypes.data.map((item: any) =>
        records.push({
          value: item.id,
          label: item.name,

          nationalityId: item.name.charAt(0) === "t" ? 1 : 2,
        })
      );

      dispatch(setIdentityCardTypes(identityCardTypes.data));

      records = records.filter(
        (record) =>
          record.nationalityId ===
          (nationalityId === TurkeyNationalityId ? 1 : 2)
      );
      setOptions(locale(records, "resources.customers.related_persons."));
    }
  }, [identityCardTypes, nationalityId]);

  if (!options || options?.length === 0) return null;
  return (
    <AutocompleteDropDown
      disableClearable={true}
      name={name}
      label={translate("resources.customers.related_persons.identityCard")}
      options={options}
      disabled={formik.values.isExistCustomer}
    />
  );
};

export default IdentityCardTypeInput;
